import React, { useEffect } from 'react';
import { TextField } from '@mui/material';
import { CalendarEventDto } from '@/types/calendar';
import { FormPayload } from './FeelingForm';

interface Props {
  disabled: boolean;
  eventToEdit?: CalendarEventDto | null;
  onChange: (payload: FormPayload) => void;
}

export const FluidForm: React.FC<Props> = ({ disabled, eventToEdit, onChange }) => {
  const [qty, setQty] = React.useState<string>('');

  useEffect(() => {
    const stored = eventToEdit?.details?.qty ?? eventToEdit?.details?.quantity ?? '';
    setQty(stored ? String(stored) : '');
  }, [eventToEdit]);

  useEffect(() => {
    const qtyNum = Number(qty);
    const valid = qty.trim() !== '' && qtyNum > 0;
    onChange({
      title: qty ? `${qty} мл` : '',
      details: { qty: qtyNum },
      isValid: valid,
    });
  }, [qty]);

  return (
    <TextField
      autoFocus
      margin="dense"
      label="Кількість (мл)"
      type="number"
      fullWidth
      variant="outlined"
      value={qty}
      onChange={(e) => setQty(e.target.value)}
      disabled={disabled}
      inputProps={{ min: 1 }}
    />
  );
};
